export { default as IndexTableRowCheckbox } from './IndexTableRowCheckbox';
